// extracted by mini-css-extract-plugin
export var subtitle = "_ad-2";
export var title = "_ad-0";
export var titleNoWrap = "_ad-1";